import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { MessageItemProps } from "./PropsType";

export default function MessageItem(props: MessageItemProps) {
  const { message, className, delay = 2500 } = props;
  const styleClass = classNames("MessageItem", className);
  const timer = useRef<NodeJS.Timeout | null>(null);
  const show = () => {
    if (timer.current) {
      return;
    }
    if (delay! > 0) {
      timer.current = setTimeout(() => {
        close();
      }, delay!);
    }
  };

  const close = () => {
    clearTimer();
    if (props.onClose) {
      props.onClose();
    }
  };

  const clearTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
  };

  useEffect(() => {
    show();
  }, []);

  return (
    <div className={styleClass}>
      <div className="MessageItem-inner">{message}</div>
    </div>
  );
}
